// extracted by mini-css-extract-plugin
export default {"flavor_option":"AX","out_of_stock_text":"BX","out_of_stock":"CX","flavor_option_image":"EX","flavor_option_info":"FX","flavor_option_title":"GX","flavor_option_limited":"HX","flavor_option_amount_wrapper":"IX","flavor_option_amount_button":"JX","zero_amount":"KX","no_flavors":"LX","no_flavors_active":"MX","flavor_option_select_wrapper":"NX","flavor_option_select_wrapper__selected":"OX"};
    if(module.hot) {
      // 1714442371285
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  